import { NewInstance } from './NewInstance';

export default NewInstance;
